<template>
  <parameter-block :content="contentArr" :showToggle="true">
    {{ $t('Web.ExpertMode.Items.Versions.Versions') }}
  </parameter-block>
</template>

<script>
import ParameterBlock from './parameterBlock';

export default {
  name: 'VersionData',
  components: { ParameterBlock },
  props: {
    device: {
      type: Object,
      default: () => {}
    },
    apiVersion: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      updateArr: false,
      contentArr: []
    };
  },
  created() {
    // TODO: use proper reactivity for array instead of the timeout
    setTimeout(() => {
      this.contentArr = [
        {
          label: this.$t('Web.expert_view_version_firmware'),
          value: (((this.device || {}).firmware || {}).build || {}).version || 'n/a'
        },
        {
          label: this.$t('Web.ExpertMode.Items.Versions.ModelName'),
          value: this.hwModelSplit(((this.device || {}).model || {}).name, 'name')
        },
        {
          label: this.$t('Web.ExpertMode.Items.Versions.ModelDate'),
          value: this.hwModelSplit(((this.device || {}).model || {}).name, 'date')
        },
        {
          label: this.$t('Web.expert_view_version_model'),
          value: ((this.device || {}).model || {}).version || 'n/a'
        },
        {
          label: this.$t('Web.expert_view_version_api'),
          value: (this.apiVersion || {}).version || 'n/a'
        }
      ];
    }, 500);
  },
  methods: {
    hwModelSplit(firmwareStr, fragment) {
      if (!firmwareStr) return 'n/a';
      const modelName = firmwareStr.match(/(?=((.+)[_][0-9]{4}))/);
      const modelDate = firmwareStr.match(/([0-9]{4}(_[0-9]{2}){4})/);

      switch (fragment) {
        case 'name':
          if (Array.isArray(modelName) && modelName.length >= 2) return modelName[2];
          return 'n/a';
        case 'date':
          if (Array.isArray(modelDate) && modelName.length >= 1) return modelDate[0];
          return 'n/a';
        default:
          return 'n/a';
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
